export const getStepProgressFooterStyles = (_, { palette = {} }) => ({
  footerContainer: {
    width: '100%',
    display: 'flex',
    clear: 'both',
    borderTop: `1px solid ${palette.neutralLight}`,
    background: palette.white,
    justifyContent: 'space-between',
    padding: '15px 24px',
  },
  footerMiddle: {
    display: 'flex',
    alignItems: 'center',
  },
  previousButton: {
    marginRight: '8px',
  },
  // For primary button border none in high contrast mode in edge
  primaryButton: {
    '&:focus::after': {
      '@media screen and (-ms-high-contrast: active)': {
        border: '1px solid white !important',
      },
    },
  },
  cancelButton: {
    marginLeft: '16px',
  },
});
